document.addEventListener('DOMContentLoaded', function () {

  const tabs = document.getElementById('pdpTabs');

  function updateStickyTop() {

    // REAL sticky header
    const header = document.querySelector('#header');

    if (!header || !tabs) return;

    const headerRect = header.getBoundingClientRect();

    /*
      bottom position of sticky header
      gives PERFECT dynamic sticky offset
    */
    const stickyTop = headerRect.bottom;

    tabs.style.setProperty(
      '--pdp-sticky-top',
      stickyTop + 'px'
    );
  }

  updateStickyTop();

  window.addEventListener('scroll', updateStickyTop, {
    passive: true
  });

  window.addEventListener('resize', updateStickyTop);

});
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.pdp-btn');
    const sections = [];

    const headerOffset = 140;

    // collect sections
    buttons.forEach((btn) => {
      const target = document.querySelector(btn.dataset.target);
      if (target) {
        sections.push({
          button: btn,
          section: target,
        });
      }
    });

    // CLICK SCROLL
    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        buttons.forEach((b) => b.classList.remove('active'));
        this.classList.add('active');

        const target = document.querySelector(this.dataset.target);

        if (target) {
          const sectionHeight = target.offsetHeight;

          // hide ~12% of section (you can tweak 0.1 → 0.15)
          const extraOffset = sectionHeight * 0.1;

          const top = target.offsetTop - headerOffset - extraOffset;

          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        }
      });
    });

    // SCROLL ACTIVE
    window.addEventListener('scroll', function () {
      let scrollPos = window.scrollY + headerOffset + 50;

      sections.forEach((item) => {
        const sectionTop = item.section.offsetTop;
        const sectionHeight = item.section.offsetHeight;

        if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
          buttons.forEach((b) => b.classList.remove('active'));
          item.button.classList.add('active');
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.getElementById('pdpTabs');
  });

  
  /* Scroll To Top Button */
document.addEventListener('DOMContentLoaded', function () {

  const scrollTopBtn = document.getElementById('pdpScrollTopBtn');

  if (!scrollTopBtn) return;

  // Show / Hide Button
  window.addEventListener('scroll', function () {

    if (window.scrollY > 400) {
      scrollTopBtn.classList.add('show');
    } else {
      scrollTopBtn.classList.remove('show');
    }

  });

  // Scroll To Top
  scrollTopBtn.addEventListener('click', function () {

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  });

});